import React, { useContext } from 'react';
import { SearchList } from '../SearchList/SearchList';
import { useAppSelector } from '../../../../../redux/store.model';
import { getGroupsByLevel } from '../../../../../redux/structure/selectors/Level.selector';
import { isLoadingStructure } from '../../../../../redux/structure/selectors/Structure.selector';
import { useParams } from 'react-router-dom';
import { SearchContext } from '../SearchBar';

interface HierarchyLevelSearchProps {
  level: string;
  label: string;
}

export const HierarchyLevelSearch = ({
  level,
  label,
}: HierarchyLevelSearchProps) => {
  const { search } = useContext(SearchContext);
  const searchQuery = search.toLowerCase();
  const { marketId } = useParams<{ marketId: string }>();

  const groups = useAppSelector((state) =>
    getGroupsByLevel(state, { workspaceId: marketId, level })
  );
  const isLoading = useAppSelector((state) =>
    isLoadingStructure(state, { workspaceId: marketId })
  );

  const filteredGroups =
    groups
      ?.filter((group) => group.name?.toLowerCase().includes(searchQuery))
      .map((item) => ({
        ...item,
        key: item.id ?? '',
        value: item.name ?? '',
      })) ?? [];

  return (
    <SearchList header={label} list={filteredGroups} loading={isLoading} />
  );
};
